<div class="wrapper fadeInDown">
    <div id="formContent">
      <!-- Tabs Titles -->
  
      <!-- Icon -->
      <div class="fadeIn first">
        <img src="../../../assets/images/user.png" style="width: 20%;height: 20%;" id="icon" alt="User Icon" />
      </div>
  
      <!-- Login Form -->
        <input type="text" id="login" class="fadeIn second" name="login" [(ngModel)]="username" placeholder="login">
        <input type="password" id="password" class="fadeIn third" name="login" [(ngModel)]="password" placeholder="password">
        <input type="submit" class="fadeIn fourth" value="Log In" (click)="login()">
  
      <!-- Remind Passowrd -->
      <div id="formFooter">
        <h4>Connectez-vous </h4>
    </div>
  
    </div>
  </div>